<template>
    <!-- 头部 -->
    <div class="head-border">
      <div class="header">
        <img src="@/assets/img/shopvidi_logo.png" class="logo_img" @click="gotoShopvidi"/>
        <el-divider direction="vertical"></el-divider>
        <div class="header-content">Wholesale Partner Program</div>
      </div>
      <div class="header-action">
        <div class="action black" @click="gotoLogin">Login</div>
        <div class="action" @click="gotoRegister">Sign Up</div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    isShowAction: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    gotoShopvidi() {
      window.open('https://www.shopvidi.com')
    },
    gotoLogin() {

    },
    gotoRegister() {

    }
  }
}
</script>

<style lang="less" scoped>
.head-border {
  position: fixed;
  background-color: #fff;
  height: 100px;
  left: 0;
  top: 0;
  z-index: 99;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .header{
    margin-left: 50px;
    display: flex;
    align-items: flex-end;
    .logo_img{
      height:45px;
      width:177px;
      cursor: pointer;
    }
    .el-divider.el-divider--vertical{
      height:20px !important
    }
  }
  .header-action{
    display: flex;
    margin-right: 50px;
    .action{
      width:114px;
      height:44px;
      border: 1px solid black;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
      cursor: pointer;
    }
    .action.black{
      background-color: black;
      color: white;
    }
  }
}
@media screen and(max-width: 600px) {
  .head-border{
    height: 50px;
    .header{
      margin-left: 10px;
      .logo_img{
        height:23px;
        width:90px;
        cursor: pointer;
      }
      .header-content{
        font-size: 10px;
        font-family: Satoshi;
        font-weight: 500;
        line-height: 20px;
        color: #262B2F;
        opacity: 1;
      }
    }
    .header-action{
      display: flex;
      margin-right: 10px;
      .action{
        width:60px;
        height:30px;
        border: 1px solid black;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .action.black{
        background-color: black;
        color: white;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/home/components/header.vue